module.exports = "mutation ($type: ON_BOARDING_PASS_TYPE) {\n    onBoardingSwitchType(type: $type)\n}\n"